import { DATE_FROM, DATE_TO } from '@query/shared';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FieldDate } from './FieldDate.js';

export interface IntervalDialogProps {
  open: boolean;
  dateFrom: string;
  dateTo: string;
  onChangeDateFrom: (value: string) => void;
  onChangeDateTo: (value: string) => void;
  onClose: () => void;
}

/** Диалог интервала дат — перенос intervalDateDialog (AppFC.kt:245-280). */
export function IntervalDialog({
  open,
  dateFrom,
  dateTo,
  onChangeDateFrom,
  onChangeDateTo,
  onClose,
}: IntervalDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Interval Date</DialogTitle>
      <DialogContent>
        <FieldDate
          id={DATE_FROM}
          label={DATE_FROM}
          defaultValue={dateFrom}
          onChange={onChangeDateFrom}
        />
        <FieldDate id={DATE_TO} label={DATE_TO} defaultValue={dateTo} onChange={onChangeDateTo} />
        <DialogActions>
          <Button onClick={onClose}>Ок</Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
